<template>
  <div id="dashboard">
    <div class="raporlarKonum">
      <div>
        <button class="ozelButon yeni card-shadow--medium" @click="raporYonlendir">
          {{ $t("rapor.raporlar") }}
        </button>
      </div>
      <div class="mt-10">
        <button class="ozelButon yeni card-shadow--medium" @click="gunlukRaporYonlendir">
          {{ $t("gunlukRapor.baslik") }}
        </button>
      </div>
    </div>
    <Siparis v-if="isAuth"/>
  </div>
</template>

<script>
import notification from '../../notification'
import Siparis from '../../components/Siparis.vue'
import musteriService from "../../WSProvider/MusteriService"

var base64 = require('base64_js');
export default {
  name: 'Dashboard',
  components: {
    Siparis
  },
  data() {
    return {
      isAuth: false,
    }
  },
  computed: {},
  methods: {
    siparisStart() {
      var item = {
        adres: '',
        adSoyad: '',
        telefon: '',
      };
      this.$store.commit('changeSiparisTur', 0);
      this.$store.commit('changeSevkiyat', item);
      this.$router.push({name: 'siparis'})
    },
    siparisStart1() {
      this.$store.commit('changeSiparisTur', 1);
      this.$router.push({name: 'sevkiyat'})
    },
    siparisStart2() {
      this.$router.push({name: 'masa'})
    },
    raporYonlendir() {
      this.$router.push({name: 'raporlar'})
    },
    gunlukRaporYonlendir() {
      this.$router.push({name: 'gunluksiparis'})
    }
  },
  mounted() {
    if (localStorage.getItem("userDataKaderFoodKasa")) {
      this.isAuth = true
      var userDataKaderFoodKasa = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKaderFoodKasa"))));
    } else {
      this.isAuth = false
      this.$store.commit('setLogout');
      this.$router.push("/login");
    }
  }
}


</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';

#dashboard {
  height: 100%;
  width: 100%;
  margin: 0 -30px;

}

.girisCard {
  margin: 5% 10%;
  position: relative;


  .el-card {
    border-radius: 18px;
    border: 1px solid #EBEEF5;
    background-color: #ffffff6e;
    overflow: hidden;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    position: relative;

    .girisBtnBg {
      position: absolute;
      background-color: #ffffff6e;
      border-radius: 10px;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      &.yeni {
        top: 50px;
        bottom: auto;
        left: 50%;
      }

      .el-button {
        margin: 10px;
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #FFFFFF;
        border: 1px solid #DCDFE6;
        border-color: #DCDFE6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: none;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 15px 60px;
        font-size: 14px;
        border-radius: 10px;
      }
    }

  }

}

.card1Bg {
  background-image: url('../../assets/images/katman/giris1.jpg');
  background-position-x: -220px;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 18px;
  height: 80vh;
}

.card2Bg {
  background: url('../../assets/images/katman/giris2.jpg') center center;
  background-size: cover;
  border-radius: 18px;
  height: 80vh;
}


@media (max-width: 1400px) {
  .giris {

    .list {
      .item {
        width: 33.33%;
      }
    }
  }
}


@media (max-width: 1100px) {
  .giris {

    .list {
      .item {
        width: 50%;
      }
    }
  }
}


@media (max-width: 900px) {
  .giris {


  }
}

@media (max-width: 768px) {
  .giris {


  }
}

@media (max-width: 480px) {
  .giris {


  }
}

.raporlarKonum {
  position: fixed;
  top: 5px;
  left: 10px;
  z-index: 99;

  button {
    background: #f9f9f9;
    padding: 10px 10px;
    outline: none;
    border: 3px solid #4a596a;
    border-radius: 10px;
    font-size: 13px !important;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
  }
}

</style>


